module.exports = __webpack_public_path__ + "static/img/valueadd9.f2f172e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd9.png
// module id = ZKek
// module chunks = 1